enum ActionType {
    SET_WATCHED_NODES = '[WATCH NODES] SET WATCHED NODES',
    SET_LOADING = '[WATCH NODES] SET LOADING',
    SET_ERROR = '[WATCH NODES] SET ERROR',
}

export default ActionType
